/* eslint-disable */ 
import './css/jquery.Jcrop.min.css'
import './css/image_cropping.css'

import './js/jquery.Jcrop.min'
import './image_cropping'